module.exports = __webpack_public_path__ + "static/lightning-modal-eff413b48cc20d51618fe22cf30fe281.png";